import { produce } from 'immer';

import * as actions from './actions';
import * as plansActions from '../plans/actions';

export default produce((state, action) => {
  switch (action.type) {

  case actions.CHANGE_USER:
    return state.map((user) => {
      if (user.id === action.user.id) {
        user = { ...user, ...action.changes };
      }

      return user;
    });

  case plansActions.SET_PLAN:
    if (action.plan.archived) {
      removePrimaryPlan(state, action.plan.id);
    }
    break;

  case plansActions.REMOVE_PLAN:
    removePrimaryPlan(state, action.plan.id);
    break;
  }
}, []);

function removePrimaryPlan(users, planId) {
  for (const user of users) {
    if (user.primaryPlanId === planId) {
      user.primaryPlanId = null;
    }
  }
}
